import React, { useEffect, useState } from "react";
import { getTeams } from "../../services/TeamService";
import { getTopBatters, getSessionStats } from "../../services/StatsService";

function Sidebar() {
    const [teams, setTeams] = useState([]);
    const [topBatters, setTopBatters] = useState([]);
    const [session, setSession] = useState(null);

    useEffect(() => {
        const fetchTeams = () => {
            getTeams().then((data) => {
                if (data && data.teams) {
                    const sorted = data.teams
                        .sort((a, b) => b.wonMatchesCount - a.wonMatchesCount);
                    setTeams(sorted);
                }
            }).catch((err) => console.log("Teams error:", err));
        };

        const fetchTopBatters = () => {
            getTopBatters(0, 5).then((data) => {
                if (data && data.players) {
                    setTopBatters(data.players);
                }
            }).catch((err) => console.log("Top batters error:", err));
        };

        const fetchSession = () => {
            getSessionStats("today").then((data) => {
                if (data && data.apiStatus) {
                    setSession(data);
                }
            }).catch((err) => console.log("Session error:", err));
        };

        fetchTeams();
        fetchTopBatters();
        fetchSession();
        const interval = setInterval(() => {
            fetchTeams();
            fetchTopBatters();
            fetchSession();
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    const getPoints = (team) => (team.wonMatchesCount * 2) + team.drawMatchesCount;

    return (
        <div className="sidebar">
            <div className="sbox">
                <div className="sbox-h">AI IPL Standings</div>
                <table className="stand-t">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th className="stand-t-left">Team</th>
                        <th>W</th>
                        <th>Pts</th>
                    </tr>
                    </thead>
                    <tbody>
                    {teams.map((team, index) => (
                        <tr key={team.teamId}>
                            <td className={`rk ${index === 0 ? "r1" : ""}`}>{index + 1}</td>
                            <td>
                                <div className="tc">
                                    {team.teamPictureURL ? (
                                        <img src={team.teamPictureURL} alt={team.name}
                                             className="stand-img"
                                             onError={(e) => { e.target.style.display = 'none'; }} />
                                    ) : <div className="team-mini-logo">🏏</div>}
                                    {team.name}
                                </div>
                            </td>
                            <td className={index < 3 ? "stand-wins-top" : ""}>{team.wonMatchesCount}</td>
                            <td className={`pts-v ${index === 9 ? "z" : ""}`}>{getPoints(team)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="sbox">
                <div className="sbox-h">Top Run Scorers</div>
                {topBatters.length === 0 ? (
                    <div className="sbox-empty">No data available</div>
                ) : (
                    <table className="stand-t">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th className="stand-t-left">Player</th>
                            <th>Runs</th>
                        </tr>
                        </thead>
                        <tbody>
                        {topBatters.map((player, index) => (
                            <tr key={player.playerId}>
                                <td className={`rk ${index === 0 ? "r1" : ""}`}>{index + 1}</td>
                                <td>
                                    <div className="tc">
                                        {player.pictureURL ? (
                                            <img src={player.pictureURL} alt={player.name}
                                                 className="stand-img"
                                                 onError={(e) => { e.target.style.display = 'none'; }} />
                                        ) : <div className="team-mini-logo">🏏</div>}
                                        {player.name}
                                    </div>
                                </td>
                                <td className="stand-runs">
                                    {player.runs?.toLocaleString()}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
            <div className="sbox">
                <div className="sbox-h">Today's Session</div>
                {session ? (
                    <div className="mstat-g">
                        <div className="mstat">
                            <div className="msl">Matches</div>
                            <div className="msv msv-neon">{session.matchesPlayed}</div>
                            <div className="mss">played today</div>
                        </div>
                        <div className="mstat">
                            <div className="msl">Avg Score</div>
                            <div className="msv msv-lime">{session.avgScore}</div>
                            <div className="mss">runs per inn.</div>
                        </div>
                        <div className="mstat">
                            <div className="msl">Sixes</div>
                            <div className="msv msv-pink">{session.totalSixes}</div>
                            <div className="mss">today</div>
                        </div>
                        <div className="mstat">
                            <div className="msl">Wickets</div>
                            <div className="msv msv-neon">{session.totalWickets}</div>
                            <div className="mss">today</div>
                        </div>
                    </div>
                ) : (
                    <div className="sbox-empty">Loading...</div>
                )}
            </div>
        </div>
    );
}

export default Sidebar;